import { render } from "./basic-profile.vue?vue&type=template&id=24bf2759&scoped=true"
import script from "./basic-profile.vue?vue&type=script&lang=js"
export * from "./basic-profile.vue?vue&type=script&lang=js"

import "./basic-profile.vue?vue&type=style&index=0&id=24bf2759&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24bf2759"]])

export default __exports__